export enum EGalleryLabelColor {
  Grey = 'grey',
  LightGrey = 'lightgrey',
  Orange = 'orange',
  Green = 'green',
  Blue = 'blue',
  Red = 'red',
}

export interface IGalleryLabel {
  label: string;
  color: EGalleryLabelColor;
}
